module.exports = __webpack_public_path__ + "img/resultAnnouncement.f7756eaf.png";